/**
 * Parse filename from a Content-Disposition header value.
 * Quoted `filename="..."` must not use a greedy `.+` past the closing quote when
 * `filename*=UTF-8''...` (RFC 5987) appears on the same line — that produced names like `foo.zip_`.
 *
 * @param {string | null | undefined} contentDisposition
 * @param {string} fallback
 * @returns {string}
 */
export function parseContentDispositionFilename(contentDisposition, fallback) {
  if (contentDisposition == null || String(contentDisposition).trim() === '') {
    return fallback;
  }
  const raw = String(contentDisposition);

  const quoted = raw.match(/filename\s*=\s*"((?:\\.|[^"\\])*)"/i);
  if (quoted && quoted[1] !== undefined && quoted[1] !== '') {
    return quoted[1].replace(/\\"/g, '"').trim();
  }

  const star = raw.match(/filename\*\s*=\s*([^;]+)/i);
  if (star && star[1]) {
    let v = star[1].trim();
    if (/^utf-8''/i.test(v)) v = v.slice(7);
    else if (v.startsWith("''")) v = v.slice(2);
    try {
      const decoded = decodeURIComponent(v);
      if (decoded) return decoded.trim();
    } catch {
      /* fall through */
    }
  }

  const unquoted = raw.match(/filename\s*=\s*([^;\s]+)/i);
  if (unquoted && unquoted[1]) {
    return unquoted[1].replace(/^["']|["']$/g, '').trim();
  }

  return fallback;
}
